module.exports = __webpack_public_path__ + "static/media/president-suite-img4.80fc43b8.jpg";